import { render, staticRenderFns } from "./ResourcesCalendar.vue?vue&type=template&id=3103b4f3&scoped=true&"
import script from "./ResourcesCalendar.vue?vue&type=script&lang=js&"
export * from "./ResourcesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesCalendar.vue?vue&type=style&index=0&id=3103b4f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3103b4f3",
  null
  
)

export default component.exports